import React from 'react';
import { Row } from 'antd';
import { CloseCircleOutlined, CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import colors from '../constants/Colors';
import OnTraccrButton from '../common/buttons/OnTraccrButton';
import Analytics from '../helpers/Analytics';
import { PORTAL_URL } from '../common/breadcrumbContainer/HelpMenu';

export default function WorkflowMarketPlaceErrorContainer({
  onClose,
  workflow,
  importWorkflow,
}) {
  if (!workflow) return null;
  const { workflow: workflowData = {}, divisions } = workflow;
  return (
    <div className="workflow-marketplace-action-overlay-error">
      <Row>
        <CloseCircleOutlined style={{ color: colors.ONTRACCR_ERROR, marginRight: 10 }} />
        <div className="workflow-marketplace-action-overlay-title" style={{ marginLeft: 0 }}>Import Failed</div>
      </Row>
      <CloseOutlined onClick={onClose} className="workflow-marketplace-action-overlay-close" />
      <div className="workflow-marketplace-action-overlay-description">
        We encountered an error while importing <b>{workflowData.name}</b>.
        This could be due to a temporary server issue or network problem.
      </div>
      <div className="workflow-marketplace-action-overlay-error-list-container">
        <div className="workflow-marketplace-action-overlay-error-list-title">What you can do:</div>
        <ul className="workflow-marketplace-action-overlay-error-list">
          <li><b>Try again</b> in a few minutes</li>
          <li>Check your <b>network connection</b></li>
          <li>Contact <b>customer support</b> if the issue persists</li>
        </ul>
      </div>
      <div className="workflow-marketplace-action-overlay-error-buttons-container">
        <OnTraccrButton
          className="workflow-marketplace-action-overlay-error-button"
          title="Try Again"
          onClick={() => {
            importWorkflow(workflowData, divisions);
            onClose();
          }}
        />
        <OnTraccrButton
          className="workflow-marketplace-action-overlay-error-button"
          title="Contact Support"
          type="cancel"
          onClick={() => {
            Analytics.track('OpenCustomerSupportPortal/Web');
            window.open(PORTAL_URL, '_blank', 'noopener');
          }}
        />
      </div>
    </div>
  );
}

WorkflowMarketPlaceErrorContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  workflow: PropTypes.shape({
    workflow: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    divisions: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  importWorkflow: PropTypes.func.isRequired,
};
